export const Pages = [
    { path: `/`, name: `الرئيسية`, name_en: `Home` },
    { path: `/about`, name: `من نحن`, name_en: `About Us` },
    { path: `/services`, name: `الخدمات`, name_en: `Services` },
    { path: `/projects`, name: `المشاريع`, name_en: `Projects` },
    { path: `/blogs`, name: `المدونة`, name_en: `Blog` },
    { path: `/ugc`, name: `صناع المحتوى`, name_en: `Bloggers` },
    { path: `/contact`, name: `تواصل معنا`, name_en: `Contact Us` },
];
